import { Fragment, useEffect } from "react";
import { useSidebar } from "../../hooks/useSidebar";
import { PrincipalSidebarDto } from "../../models/Sidebar.model";
import { pathImages } from "../../routes/endpoints";
import { handleOpenPage } from "../../helpers/home/helper";
import { normalizeTitle } from "../../helpers/sidebar/helper";
import './nav.css';

export const Nav = () => {
    const {
        isShowMenu,
        menuPrincipal,
        menuOpen,
        menuData,
        getMenuById,
        handleShowMenu,
        handleMenuClick,
    } = useSidebar();

    useEffect(() => {
        getMenuById("0");
    }, []);

    const renderMenuItem = (item: PrincipalSidebarDto, nivel = 1) => (
        <div className={`nav-item ${item.url || item.pdf ? "ms-4" : "dropdown ms-4"}`} key={item.id} style={{ fontSize: 18}}>
            {item.url || item.pdf ? (
                <div className="d-flex align-items-center">
                    {item.idPadre === "0" && item.icono ?
                        <img
                            className="logo-sidebar me-3"
                            src={`${pathImages}${item.icono}`}
                            height={25}
                            alt="logo-sidebar" />
                        :
                        null
                    }
                    <a className={`nav-link ms-2 text-wrap ${item.idPadre === "0" ? "fw-bold" : ""}`} href={"#"} onClick={(e) => handleOpenPage(e, item.url, item.pdf)}>{item.titulo}</a>
                </div>
            ) : (
                <a
                    className={`dropdown-item nav-link d-flex btn-flecha ${item.idPadre === "0" ? "fw-bold" : ""}`}
                    href={`#${normalizeTitle(item.titulo)}`}
                    data-bs-toggle="collapse"
                    aria-expanded={menuData[item.titulo] ? true : false}
                    aria-controls={normalizeTitle(item.titulo)}
                    onClick={(e) => {
                        e.preventDefault();
                        handleMenuClick(item.id, item.titulo)
                    }}
                >
                    <div className="d-flex align-items-center">
                        {item.idPadre === "0" && item.icono ?
                            <img
                                className="logo-sidebar me-1"
                                src={`${pathImages}${item.icono}`}
                                height={25}
                                alt="logo-sidebar" />
                            :
                            null
                        }
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path
                                d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        <p className="ms-1 text-wrap">{item.titulo}</p>
                    </div>
                </a>
            )}
            {recursiveFn(item.titulo, nivel + 1)}
        </div>
    );

    const recursiveFn = (titulo: string, nivel = 1) => {
        const data = menuData[titulo];
        if (!data || nivel > 8) {
            return null;
        }
        return (
            <div className={`collapse ${menuOpen ? "show" : ""}`} id={normalizeTitle(titulo)} style={{ overflow: "hidden" }}>
                {data.map(item => renderMenuItem(item, nivel))}
            </div>
        );
    };

    return (
        <nav className="navbar navbar-dark fixed-menu navbar-boton">
            <div className="container-fluid">
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasDarkNavbar"
                    aria-controls="offcanvasDarkNavbar"
                    aria-label="Toggle navigation"
                    aria-modal={isShowMenu}
                    role={isShowMenu ? "dialog" : ""}
                    onClick={() => handleShowMenu(!isShowMenu)}>
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`offcanvas offcanvas-end text-bg-purple ${isShowMenu && "show"}`} tabIndex={-1} id="offcanvasDarkNavbar" aria-labelledby="offcanvasDarkNavbarLabel">
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="offcanvasDarkNavbarLabel">MENÚ DE TRANSPARENCIA</h5>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                            onClick={() => handleShowMenu(false)}
                        ></button>
                    </div>
                    <div className="offcanvas-body">
                        <div className="navbar-nav justify-content-end flex-grow-1 pe-3 text-start">
                            <div className="nav-item">
                                <a className="nav-link active" aria-current="page" href="#">Inicio</a>
                            </div>
                            {menuPrincipal.map(item => (
                                <Fragment key={item.id}>
                                    {renderMenuItem(item)}
                                    <li className="border-top my-1"></li>
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                {isShowMenu && <div className="offcanvas-backdrop fade show" onClick={() => handleShowMenu(false)}></div>}
            </div>
        </nav>
    );
};
